import React from 'react'
import { CreditApplication } from '_gql'

import { useMakeTestId } from '@divvy-web/hooks.usenameformatter'
import { FormattedMessage } from '@divvy-web/i18n'

import { StatusButtons } from '@sputnik/components'
import ImageWrapper from '@sputnik/components/ImageWrapper/ImageWrapper'
import StatusTile from '@sputnik/pages/Dashboard/StatusTile/StatusTile'
import { PATHNAME_CONSTS } from '@sputnik/resources/constants'

interface CorrectionsRequestedStatusTileProps {
  creditApp: CreditApplication
}

// this tile shows when the CreditApplicationStatus === "CORRECTION_REQUESTED"
const CorrectionsRequestedStatusTile = ({ creditApp }: CorrectionsRequestedStatusTileProps) => {
  const makeTestId = useMakeTestId('CorrectionsRequestedStatusTile')
  const { salesforceCreditId, lastUpdatedByApplicantAt } = creditApp || {}

  return (
    <div data-testid={makeTestId('')}>
      <StatusTile
        creditApp={creditApp}
        image={
          <ImageWrapper
            alt='pen making marks'
            imageName='dashboard-application-correction-status'
          />
        }
        primaryInfo={
          <FormattedMessage
            defaultMessage='Some of the information submitted doesn’t match our records and needs to be corrected. Please update ASAP.'
            id='sputnik.CorrectionsRequestedStatusTile__CJCVwy'
          />
        }
        secondaryInfo={
          <FormattedMessage
            defaultMessage='Last updated on {date, date, long}'
            id='sputnik.CorrectionsRequestedStatusTile__7CIzhR'
            values={{ date: new Date(lastUpdatedByApplicantAt) }}
          />
        }
        title={
          <FormattedMessage
            defaultMessage='Application correction'
            id='sputnik.CorrectionsRequestedStatusTile__fsWoDc'
          />
        }
      >
        <StatusButtons
          hideSecondary={true}
          primaryPath={`/app/${salesforceCreditId}/${PATHNAME_CONSTS.REVIEW_PATH}`}
          primaryText={
            <FormattedMessage
              defaultMessage='Correct application'
              id='sputnik.CorrectionsRequestedStatusTile__AZtNO2'
            />
          }
        />
      </StatusTile>
    </div>
  )
}

export default CorrectionsRequestedStatusTile
